import React, { useState } from 'react';
import logo from '../../assets/images/logo.svg';

function Drawer({ drawer, action }) {
    const [itemSize, setSize] = useState('0px');
    const [item, setItem] = useState('download');
    const handler = (e, value) => {
        // e.preventDefault();
        const getItems = document.querySelectorAll(`#${value} li`).length;
        if (getItems > 0) {
            setSize(`${43 * getItems}px`);
            setItem(value);
        }
    };
    return (
        <>
            <>
                <div
                    onClick={(e) => action(e)}
                    className={`off_canvars_overlay ${drawer ? 'active' : ''}`}
                ></div>
                <div
                    onClick={(e) => action(e)}
                    className={`off_canvars_overlay ${drawer ? 'active' : ''}`}
                ></div>
                <div className="offcanvas_menu">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className={`offcanvas_menu_wrapper ${drawer ? 'active' : ''}`}>
                                    <div className="canvas_close">
                                        <a href="#" onClick={(e) => action(e)}>
                                            <i className="fa fa-times"></i>
                                        </a>
                                    </div>
                                    <div className="offcanvas-brand text-center mb-40">
                                        <img src={logo} alt="" />
                                    </div>
                                    <div id="menu" className="text-left ">
                                        <ul className="offcanvas_main_menu">
                                            <li
                                                onClick={(e) => handler(e, 'download')}
                                                id="download"
                                                className="menu-item-has-children active"
                                            >
                                                <span className="menu-expand">
                                                    <i className="fa fa-angle-down"></i>
                                                </span>
                                                <a href="#">Download</a>
                                                <ul
                                                    className="sub-menu"
                                                    style={{
                                                        height:
                                                            item === 'download' ? itemSize : '0px',
                                                    }}
                                                >
                                                    <li>
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://play.google.com/store/apps/details?id=com.axiel7.moelist"
                                                            target="_blank"
                                                        >
                                                            From Play Store
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://apt.izzysoft.de/fdroid/index/apk/com.axiel7.moelist"
                                                            target="_blank"
                                                        >
                                                            From F-Droid
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://github.com/axiel7/MoeList/releases/latest"
                                                            target="_blank"
                                                        >
                                                            From GitHub
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li
                                                onClick={(e) => handler(e, 'support')}
                                                id="support"
                                                className="menu-item-has-children active"
                                            >
                                                <span className="menu-expand">
                                                    <i className="fa fa-angle-down"></i>
                                                </span>
                                                <a href="#">Support</a>
                                                <ul
                                                    className="sub-menu"
                                                    style={{
                                                        height:
                                                            item === 'support' ? itemSize : '0px',
                                                    }}
                                                >
                                                    <li>
                                                        <a
                                                            rel="noreferrer"
                                                            href="https://discord.gg/CTv3WdfxHh"
                                                            target="_blank"
                                                        >
                                                            Discord
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="mailto://contacto.axiel7@gmail.com">
                                                            E-Mail
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="mailto://support@lunoxia.de">
                                                            Website related
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li
                                                onClick={(e) => handler(e, 'crowdin')}
                                                id="crowdin"
                                                className="menu-item-has-children active"
                                            >
                                                <a
                                                    rel="noreferrer"
                                                    href="https://crowdin.com/project/moelist"
                                                    target="_blank"
                                                >
                                                    Crowdin
                                                </a>
                                            </li>
                                            <li
                                                onClick={(e) => handler(e, 'github')}
                                                id="github"
                                                className="menu-item-has-children active"
                                            >
                                                <a
                                                    rel="noreferrer"
                                                    href="https://github.com/axiel7/MoeList"
                                                    target="_blank"
                                                >
                                                    Github
                                                </a>
                                            </li>
                                            <li
                                                onClick={(e) => handler(e, 'creator')}
                                                id="creator"
                                                className="menu-item-has-children active"
                                            >
                                                <a
                                                    rel="noreferrer"
                                                    href="https://axiel7.github.io"
                                                    target="_blank"
                                                >
                                                    Creator
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="footer-widget-info">
                                        <ul>
                                            <li>
                                                <a
                                                    rel="noreferrer"
                                                    href="mailto://contacto.axiel7@gmail.com"
                                                    target="_blank"
                                                >
                                                    <i className="fal fa-envelope" />
                                                    contacto.axiel7@gmail.com
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    rel="noreferrer"
                                                    href="mailto://support@lunoxia.de"
                                                    target="_blank"
                                                >
                                                    <i className="fal fa-globe" />
                                                    support@lunoxia.de
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    rel="noreferrer"
                                                    href="https://discord.gg/CTv3WdfxHh"
                                                    target="_blank"
                                                >
                                                    <i className="fab fa-discord" />
                                                    discord.gg/CTv3WdfxHh
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    );
}

export default Drawer;
